<template>
  <Layout
    class="live-page"
    :class="{
      'is-live': webcast.status == 'live',
      hasStreams: hasStreams,
      hasCTA: pageSettings.callToActionEnabled,
    }"
  >
    <Navbar />
    <Layout class="main-layout" v-if="isReady">
      <Content class="live-content2" style="overflow: visible">
        <LivePlayer
          v-if="!webcast.enableP2P"
          :isSidebarCollapsed="isCollapsed"
        ></LivePlayer>
        <question-form :senderInfo="senderInfo"></question-form>
      </Content>
    </Layout>
  </Layout>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Navbar from '@/components/Navbar.vue'
import LivePlayer from '@/components/LivePlayer2.vue'
import LivePlayerP2P from '@/components/LivePlayerP2P.vue'
import WidgetContainer from '@/components/widgets/WidgetContainer.vue'
import QuestionForm from '@/components/qna/QuestionForm3.vue'

export default {
  name: 'live',
  components: {
    LivePlayer,
    LivePlayerP2P,
    WidgetContainer,
    Navbar,
    QuestionForm
  },
  data() {
    return {
      attId: '',
      isCollapsed: false,
      isReady: false,
      sidebarContent: null
    }
  },
  computed: {
    ...mapGetters('stream', {
      streamsInStore: 'find',
      getStreamInStore: 'get'
    }),
    ...mapGetters('registrations', {
      registration: 'getCopy'
    }),
    ...mapGetters('page-settings', {
      pageSettings: 'getCopy'
    }),
    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),
    ...mapGetters('widgets', {
      findWidgetsInStore: 'find'
    }),
    widgets() {
      return this.findWidgetsInStore().data
    },
    hasWidgets() {
      if (this.widgets.length >= 1) {
        return true
      } else {
        return false
      }
    },
    siderIcon() {
      if (this.isCollapsed) {
        return 'ios-arrow-back'
      } else {
        return 'ios-arrow-forward'
      }
    },
    hasStreams() {
      if (this.webcast.status != 'live') return false
      else if (this.streamsInStore().data.length > 1) return true
      else return false
    }
  },
  watch: {},
  methods: {
    ...mapActions('registrations', {
      initUserAction: 'initUser'
    }),
    ...mapActions('widgets', {
      findWidgetsAction: 'find'
    }),

    collapsedSider() {
      this.$refs.sider.toggleCollapse()
    },

    openWidget(index) {
      let widget = this.widgets[index]

      if (_.isEqual(this.currentWidget, widget) || this.isCollapsed) {
        this.collapsedSider()
      }
      this.currentWidget = widget
      //console.log(this.currentWidget);
    },

    closeWidget() {
      this.collapsedSider()
      //this.currentWidget = undefined
    }
  },
  created() {
    console.log('genXLive')
    this.$store.commit('widgets/clearAll')
    this.senderInfo = {
      name: this.registration.name,
      location: this.registration.location
    }
    this.findWidgetsAction({ query: { webcastId: this.webcast._id } }).then(
      res => {
        if (this.hasWidgets) {
          this.$data.isCollapsed = false
        } else {
          this.$data.isCollapsed = true
        }

        this.$set(this.$data, 'isReady', true)

        //console.log(this.$data.currentWidget);
      }
    )
  }
}
</script>

<style lang="less" scoped>
.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  vertical-align: middle;
  font-size: 22px;
}

.sider-toggle-btn {
  position: absolute;
  right: 485px;
  width: 36px !important;
  height: 36px !important;
  top: 70px;
  &.collapsed {
    right: 10px;
  }
}

.live-page {
  .live-player-wrapper2 {
    //max-width: 854px;
  }
  .live-content2 {
    //padding-top: 64px;
    //background-color: #f5f5f6;
    margin: auto;
    padding-top: 6.05vw;
    max-width: 46.6vw;
    padding-left: 0.3vw;
  }
  @media screen and (max-width: 992px) {
    .live-content2 {
      //padding-top: 64px;
      //background-color: #f5f5f6;
      width: 100%;
      margin: auto;
      padding-top: 0;
      max-width: 100%;
    }
  }
}

.live-sider {
  //border-left: 1px solid #e9eaec;
  padding-top: 64px;
}

@media screen and (max-width: 992px) {
  .poweredby_logo {
    background-image: url(/img/powered_by_logo.png);
    background-color: transparent;
    width: 96px;
    height: 66px;
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 0.2;
    left: 32px;
    position: absolute;
    bottom: 0px;
  }

  .main-layout {
    padding-top: 0px !important;
  }
  .ivu-layout-header {
    display: none;
  }
}
</style>
